import React, { ReactNode } from 'react'
import styled from 'styled-components'
import { useAssetVizTheme } from '../providers/theme'

export const TooltipContainer = styled.div<{
  $background: string
  $textColor: string
}>`
  user-select: none;
  pointer-events: none;
  white-space: nowrap;
  border-radius: 0.25rem;
  padding: 1rem;
  max-width: 30vw;
  min-width: 20rem;
  background-color: ${({ $background }) => $background};
  color: ${({ $textColor }) => $textColor};
`
const BottomRightHelperText = styled.div`
  margin: 6px -8px -12px;
  font-family: sans-serif;
  font-style: italic;
  text-align: right;
  color: inherit;
`

export const VizTooltipContainer: React.FC<{
  isFrozen: boolean | undefined
  children: ReactNode
}> = ({ isFrozen, children }) => {
  const theme = useAssetVizTheme()
  const helperText = isFrozen ? 'Press F to unfreeze' : 'Press F to freeze'

  return (
    <TooltipContainer
      $background={theme.background1}
      $textColor={theme.defaultText}>
      {children}
      <BottomRightHelperText data-html2canvas-ignore>
        {helperText}
      </BottomRightHelperText>
    </TooltipContainer>
  )
}
